import React, { useState, useEffect, useRef } from 'react';
import { Select, Row, Col, Form, Button } from 'antd';
import Input from '../../ui/Input';
import { getOTACodes } from '../../../services/common'
import Loading from '../../Loading';
import { PlusOutlined } from '@ant-design/icons';
import Schedule from './Schedule';
import Collapse, { Panel } from '../../ui/Collapse';
const FormItem = Form.Item;
const Option = Select.Option;
interface propsTypes {
    addLoading: void | any,
    validateFieldsError: void | any,
    currentForm: any
}
interface dataType {
    type: string,
    typedetail: string,
    inclunded: string,
    description: string,
    charge: '',
    currency: string,
    chargeunit: string,
    schedule: [{
        startDatePicker: string,
        operationtime: [
            {
                dayoftheweek: string,
                starttime: string,
                endtime: string
            },
            {
                dayoftheweek: string,
                starttime: string,
                endtime: string
            },
            {
                dayoftheweek: string,
                starttime: string,
                endtime: string
            },
            {
                dayoftheweek: string,
                starttime: string,
                endtime: string
            },
            {
                dayoftheweek: string,
                starttime: string,
                endtime: string
            },
            {
                dayoftheweek: string,
                starttime: string,
                endtime: string
            },
            {
                dayoftheweek: string,
                starttime: string,
                endtime: string
            },

        ]
    }
    ]
}
const TransportationEdit = (props: propsTypes | any) => {
    const [reftypeData, seReftypeData] = useState<Array<any>>([])
    const [currencyData, setCurrencyData] = useState<Array<any>>([])
    const [isRequired, setIsRequired] = useState(true)
    const [refreshCount, setRefreshCount] = useState(0)
    let transportation = props?.rowData?.transportation || []
    const scheduleRef: any = useRef();
    for (let key in transportation) {
        transportation[key].id = Number(key)
    }
    const getDefaultOpenKeys = (transportation: dataType[]) => Array.from(transportation).map((v, k) => `${k}`);
    const [detailData, setDetailData] = useState(transportation)
    const [defaultOpenKeys, setDefaultOpenKeys] = useState(getDefaultOpenKeys(detailData))
    const typeData = async () => {
        let res = await getOTACodes('TRP', '')
        if (res && res.otacodes && res.otacodes.length != 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            seReftypeData(res.otacodes)
        } else {
            seReftypeData([])
        }
    };
    const currenData = async () => {
        let res = await getOTACodes('CUR', '')
        if (res && res.otacodes && res.otacodes.length != 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            setCurrencyData(res.otacodes)
        } else {
            setCurrencyData([])
        }
    };
    const addCertification = () => {
        if (!isRequired) {
            setIsRequired(true)
        }
        const newDetails = ([{
            type: ' ',
            typedetail: ' ',
            inclunded: ' ',
            description: ' ',
            charge: ' ',
            currency: ' ',
            chargeunit: ' ',
            schedule: [{
                startDatePicker: ' ',
                operationtime: [
                    {
                        dayoftheweek: "Mon",
                        starttime: " ",
                        endtime: " "
                    },
                    {
                        dayoftheweek: "Tue",
                        starttime: " ",
                        endtime: " "
                    },
                    {
                        dayoftheweek: "Wed",
                        starttime: " ",
                        endtime: " "
                    },
                    {
                        dayoftheweek: "Thu",
                        starttime: "",
                        endtime: ""
                    },
                    {
                        dayoftheweek: "Fri",
                        starttime: "",
                        endtime: ""
                    },
                    {
                        dayoftheweek: "Sat",
                        starttime: "",
                        endtime: ""
                    },
                    {
                        dayoftheweek: "Sun",
                        starttime: "",
                        endtime: ""
                    },

                ]
            }
            ]
        }])
        const newDetail = JSON.parse(JSON.stringify(detailData)).concat(newDetails)
        setDetailData(newDetail)
        setDefaultOpenKeys(getDefaultOpenKeys(newDetail))
        setRefreshCount(refreshCount + 1)
    }
    useEffect(() => {
        props.validateFieldsError();
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [detailData])
    
    const deleteItem = (index: number) => {
        const newDetailData = detailData.filter((item: any) => item)
        if (newDetailData.length === 1) {
            const newDetails = ([{
                type: '',
                typedetail: '',
                inclunded: '',
                description: '',
                charge: '',
                currency: '',
                chargeunit: '',
                schedule: [{
                    startDatePicker: '',
                    operationtime: [
                        {
                            dayoftheweek: "Mon",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Tue",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Wed",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Thu",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Fri",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Sat",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Sun",
                            starttime: "",
                            endtime: ""
                        },

                    ]
                }
                ]
            }])
            props.currentForm.setFieldsValue({ transportation: newDetails })
            scheduleRef.current.resetSchedule();
            setIsRequired(false)
        } else {
            const newValue = detailData ? detailData.map((item: any, _index: number) => {
                if (_index === index && newDetailData.length > 1) {
                    return null;
                }
                return item;
            }) : [];
            setDetailData(newValue);
        }
    }
    const onChangeItem = () => {
        setIsRequired(true)
    }
    useEffect(() => {
        typeData()
        currenData()
    }, [])
    return (props.addLoading ? <Loading type="large" /> :
        <div style={{ paddingLeft: 16 }}>
            <Collapse defaultActiveKey={defaultOpenKeys} multiCollapseButton key={refreshCount}>
                {
                    detailData.map((item: any, i: number) => (
                        <React.Fragment key={i}>
                            {item ? <Panel
                                header={`Transportation ${i + 1}`}
                                key={i}
                                deleteButton={{
                                    action: () => deleteItem(i),
                                    title: `Are you sure you want to delete Transportation ${i + 1}?`,
                                }}
                            >
                                <Row gutter={24}>
                                    <Col span={6}>
                                        <FormItem name={['transportation', i, 'type']} label="Type" rules={[{ required: false, message: 'This field is required' }]}>
                                            <Select allowClear onChange={onChangeItem} showSearch>
                                                {reftypeData && reftypeData.length ? reftypeData.map((item) => {
                                                    return (
                                                        <Select.Option value={item.codeName} key={item.codeName} showSearch>{item.codeName}</Select.Option>
                                                    )
                                                }) : null}
                                            </Select>
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={12}>
                                        <FormItem name={['transportation', i, 'typedetail']} label="Type Detail" rules={[{ max: 2000, message: 'You have reached the max character length of 2000' }]}>
                                            <Input maxLength={2000} onChange={onChangeItem} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={6}>
                                        <FormItem name={['transportation', i, 'included']} label="Included">
                                            <Select allowClear onChange={onChangeItem} showSearch>
                                                <Option value="true">Yes</Option>
                                                <Option value="false">No</Option>
                                            </Select>
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={12}>
                                        <FormItem name={['transportation', i, 'description']} label="Description" rules={[{ max: 100, message: 'You have reached the max character length of 100' }]}>
                                            <Input maxLength={100} onChange={onChangeItem} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={6}>
                                        <FormItem name={['transportation', i, 'charge']} label="Charge(Amount)" rules={[{ pattern: /^\d*(\.\d*)?$/, message: 'This field should be a number' }]} >
                                            <Input onChange={onChangeItem} />
                                        </FormItem>
                                    </Col>
                                    <Col span={6}>
                                        <FormItem name={['transportation', i, 'currency']} label="Currency">
                                            <Select allowClear onChange={onChangeItem} showSearch>
                                                {currencyData && currencyData.length ? currencyData.map((item) => {
                                                    return (
                                                        <Select.Option value={item.codeName} key={item.codeName} showSearch>{item.codeName}</Select.Option>
                                                    )
                                                }) : null}
                                            </Select>
                                        </FormItem>
                                    </Col>
                                    <Col span={6}>
                                        <FormItem name={['transportation', i, 'chargeunit']} label="Charge Unit">
                                            <Select allowClear onChange={onChangeItem} showSearch>
                                                <Option value="One Way">One Way</Option>
                                                <Option value="Round Trip">Round Trip</Option>
                                            </Select>
                                        </FormItem>
                                    </Col>
                                </Row>
                                <FormItem style={{ marginBottom: '0px' }} name={['transportation', i, 'schedule']}>
                                    <Schedule ref={scheduleRef} onChangeItem={onChangeItem} />
                                </FormItem>
                            </Panel> : null}
                        </React.Fragment>
                    ))
                }
            </Collapse>
            <Button
                type="link"
                onClick={() => {
                    addCertification()
                }}
                icon={<PlusOutlined />}
                style={{ display: 'flex', alignItems: 'center', background: '#fff', float: 'right' }}
            >
                Add Transportation {detailData.length + 1}
            </Button>
        </div>
    )
}

export default TransportationEdit;

